








































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import autosize from 'autosize'
import linkifyHtml from 'linkifyjs/html'
import escape from 'lodash/escape'
import concat from 'lodash/concat'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { nickname } from '@/utils/nickname'
import { MessageRequest } from '@/types/message'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'

dayjs.locale('fr')

type Origin = 'other' | 'me'

interface Message {
    content: string
    origin: Origin
    nickname: string
    date: Date
}

@Component({
    filters: {
        formatDate(value: Date): string {
            return dayjs(value)
                .format('D MMM à H:mm')
                .toString()
        },
    },
})
export default class Messagerie extends Vue {
    @Prop() threadID: number

    loading = true
    hidden = true
    userID: number
    messageContent: string = ''
    messages: Message[] = []

    escape(value: string): string {
        return escape(value)
    }

    linkifyHtml(value: string): string {
        return linkifyHtml(value, {
            className:
                'text-white font-weight-bold text-underline text-break-line',
        })
    }
    get lastMessageDate() {
        if (this.messages.length) {
            return this.messages[this.messages.length - 1].date
        }
    }

    loadMore() {
        const newMessages: Message[] = [...Array(5).keys()].map(x => ({
            nickname: 'John.D',
            content: `Message`,
            origin: ['other', 'me'][x % 2] as Origin,
            date: new Date(),
        }))
        this.prependMessages(newMessages)
    }

    /**
     * Cette fonction permet d'empecher le scroll auto lors de l'ajout de
     * messages au début du tableau.
     */
    prependMessages(messages: Message[]) {
        const scrollView = this.$refs.scrollView as HTMLElement
        const scrollTop = scrollView.scrollTop
        const scrollHeight = scrollView.scrollHeight

        this.messages = concat(messages, this.messages)

        scrollView.scrollTo(
            0,
            scrollView.scrollHeight - scrollHeight + scrollTop
        )
        requestAnimationFrame(() => {
            scrollView.scrollTo(
                0,
                scrollView.scrollHeight - scrollHeight + scrollTop
            )
        })
        setTimeout(() => {
            scrollView.scrollTo(
                0,
                scrollView.scrollHeight - scrollHeight + scrollTop
            )
        }, 1)
    }

    async sendMessage() {
        if (this.messageContent.trim().length === 0) {
            return
        }

        const messageContent = this.messageContent.trim()

        try {
            const request: MessageRequest = {
                content: messageContent,
                thread: this.threadID,
            }

            const apiService = new ApiService()
            await apiService.postMessage(request)

            this.messages.push({
                nickname: 'Moi',
                content: this.messageContent.trim(),
                origin: 'me',
                date: new Date(),
            })
            this.messageContent = ''

            requestAnimationFrame(() => {
                const input = this.$refs.input as HTMLElement
                autosize.update(input)
            })
            requestAnimationFrame(() => {
                this.scrollToBottom()
            })
        } catch (e) {
            console.log(e)
        }
    }

    scrollToBottom(animation: boolean = true) {
        const scrollView = this.$refs.scrollView as any
        scrollView.scrollTo({
            top: 999999999,
            behavior: animation ? 'smooth' : 'instant',
        })
    }

    mounted() {
        const input = this.$refs.input as HTMLElement
        autosize(input)

        this.scrollToBottom()
    }

    destroyed() {
        const input = this.$refs.input as HTMLElement
        autosize.destroy(input)
    }

    onKeypress(event: KeyboardEvent) {
        if (event.key === 'Enter' && event.ctrlKey) {
            this.sendMessage()
        }
    }

    async created() {
        await UserModule.Init()
        this.userID = UserModule.userInfos.id
    }

    @Watch('threadID')
    async onThreadID() {
        if (!this.threadID) {
            return
        }

        const apiService = new ApiService()
        const messagesResp = await apiService.getMessages(this.threadID)
        const messages = messagesResp.data

        this.messages = messages.map(message => ({
            nickname:
                message.user.id === this.userID
                    ? 'Moi'
                    : nickname(message.user.firstname, message.user.lastname),
            content: message.content,
            origin:
                message.user.id === this.userID ? 'me' : ('other' as Origin),
            date: new Date(message.createdAt),
        }))

        this.loading = false
    }

    afterTransition() {
        this.scrollToBottom(false)
        requestAnimationFrame(() => {
            this.hidden = false
        })
    }
}
